import type { ComponentProps } from "react";

import { ReviewCardTemplate } from "./card-template";

import { StarRatingScaleSkeleton } from "~/entities/review";
import { Skeleton } from "~/shared/ui/skeleton";

type Props = Omit<
  ComponentProps<typeof ReviewCardTemplate>,
  "avatar" | "fullName" | "createdAt" | "ratingScale" | "reviewContent"
>;

function ReviewCardSkeleton({ ...props }: Props) {
  return (
    <ReviewCardTemplate
      avatar={<Skeleton className="size-12 rounded-full" />}
      fullName={<Skeleton className="h-6 w-32" />}
      createdAt={<Skeleton className="h-5 w-40" />}
      ratingScale={<StarRatingScaleSkeleton />}
      reviewContent={
        Object.fromEntries(
          (
            ["pros", "cons", "text"] satisfies (keyof ComponentProps<
              typeof ReviewCardTemplate
            >["reviewContent"])[]
          ).map((value) => [value, <Skeleton key={value} className="h-18 w-full" />] as const),
        ) as ComponentProps<typeof ReviewCardTemplate>["reviewContent"]
      }
      {...props}
    />
  );
}

export { ReviewCardSkeleton };
